import Head from 'next/head';
import { useWistiaScript } from './WistiaVideo.context';

/**
 * In case you wonder why E-v1.js is important for Wistia.
 *
 * Feel free to read: https://wistia.com/support/developers/e-v1
 */

export function WistiaControlScript() {
  const { isWistiaOnThePage } = useWistiaScript();

  return isWistiaOnThePage ? (
    <Head>
      <script
        defer={true}
        src="https://fast.wistia.com/assets/external/E-v1.js"
      />
    </Head>
  ) : null;
}
